// @ts-nocheck
/* eslint-disable */
export const appChevronLeft40Icon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5 12L16 20.5L24.5 29" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-left-40' as const
};